import React from 'react';
import H1 from './H1';

export default function FormTitle(props) {
  return (
    <H1 className="pb-6">{props.children}</H1>
  )
}
